<template>
	<main-container>
		<material-card icon="fas fa-book" :title="$t('incomedeclarations.table_title')" importElement="AdminIncomeDeclarations" :exportElement="{ element: 'AdminIncomeDeclarations', types: ['xls'] }" :selected="selected_adminincomedeclarations" @unselectAll="selected_adminincomedeclarations = []">
			<template slot="delete-actions">
				<v-btn icon link @click="deleteAdminIncomeDeclarations()">
					<v-icon>far fa-trash-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="5">
					<search-box v-model="adminincomedeclarations_options.search" nocolor @change="adminincomedeclarations_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table @click-action="editAdminIncomeDeclarations" :selected.sync="selected_adminincomedeclarations" show-select :headers="adminincomedeclarations_headers" :items="adminincomedeclarations.data" :options.sync="adminincomedeclarations_options" :server-items-length="adminincomedeclarations.total" :loading="adminincomedeclarations_loading">
				<template v-slot:item.date="{ item }">{{ $formatters.frontEndDateFormat(item.date) }}</template>
				<template v-slot:item.tax="{ item }">{{ $formatters.formatCurrency(item.tax) }}</template>
				<template v-slot:item.contribute="{ item }">{{ $formatters.formatCurrency(item.contribute) }}</template>
				<template v-slot:item.taxable="{ item }">{{ $formatters.formatCurrency(item.taxable) }}</template>
				<template v-slot:item.attachments="{ item }">
					<v-badge :value="$functions.attachmentsCount(item) != 0" color="secondary" overlap right :content="$functions.attachmentsCount(item)" v-if="$functions.attachmentsCount(item) != 0">
						<v-btn icon small @click.stop="showIncomeDeclarationsAttachment(item)" :disabled="adminincomedeclarations_loading"><v-icon>fas fa-paperclip</v-icon></v-btn>
					</v-badge>
				</template>
			</material-table>
		</material-card>
		<create-edit-adminincomedeclarations v-if="showCreateEditAdminIncomeDeclarations"></create-edit-adminincomedeclarations>
		<import-adminincomedeclarations v-if="showImportAdminIncomeDeclarations"></import-adminincomedeclarations>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originaladminincomedeclarations_options: null,
		selected_adminincomedeclarations: [],
	}),
	computed: {
		showImportAdminIncomeDeclarations() {
			return this.$store.getters.showImportAdminIncomeDeclarations;
		},
		dateFilterName() {
			if (this.adminincomedeclarations_options.date_start != null) {
				return "Date filtrate";
			}
			return null;
		},
		isCustomDateFilter() {
			if (this.adminincomedeclarations_options.datefiltertype) {
				return this.$appOptions.dateFilter(this.adminincomedeclarations_options.datefiltertype).value == "custom";
			}
			return false;
		},
		showCreateEditAdminIncomeDeclarations() {
			return this.$store.getters.showCreateEditAdminIncomeDeclarations;
		},
		adminincomedeclarations_headers() {
			let headers = [];
			headers.push({
				text: this.$t("incomedeclarations.tenant"),
				value: "tenant.fullname",
				align: "left",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.ref_year"),
				value: "ref_year",
				align: "left",
				sortable: true,
				width: "1%",
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.tax"),
				value: "tax",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.contribute"),
				value: "contribute",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.taxable"),
				value: "taxable",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: "",
				value: "attachments",
				align: "center",
				sortable: false,
				selected: true,
				width: "1%",
			});
			return { data: headers, id: "incomedeclarations_headers" };
		},
		adminincomedeclarations_options: {
			get: function () {
				return this.$store.getters.getAdminIncomeDeclarationsOptions;
			},
			set: function (value) {
				this.$store.commit("setAdminIncomeDeclarationsOptions", value);
			},
		},
		adminincomedeclarations() {
			return this.$store.getters.getAdminIncomeDeclarations;
		},
		adminincomedeclarations_loading() {
			return this.$store.getters.adminincomedeclarations_loading;
		},
	},
	methods: {
		showAdminIncomeDeclarationsAttachment(item) {
			this.$store.dispatch("setCurrentModelForAttachment", {
				object: item,
				filecategory: "incomedeclarations",
				show: true,
			});
		},
		updateDateFilter() {
			if (!this.isCustomDateFilter) {
				let options = _.cloneDeep(this.adminincomedeclarations_options);
				if (options.datefiltertype != null) {
					let dates = this.$appOptions.dateFilter(options.datefiltertype);
					options.date_start = dates.date_start;
					options.date_end = dates.date_end;
				} else {
					options.date_start = null;
					options.date_end = null;
				}
				this.adminincomedeclarations_options = options;
			}
		},
		loadAdminIncomeDeclarations() {
			const self = this;
			if (self.$functions.ObjectAreEqual(self.originaladminincomedeclarations_options, self.adminincomedeclarations_options) == false) {
				self.originaladminincomedeclarations_options = _.cloneDeep(self.adminincomedeclarations_options);
				self.$store.dispatch("fetchAdminIncomeDeclarations");
			}
		},
		editAdminIncomeDeclarations(item) {
			this.$store.dispatch("setCurrentModelForAttachment", {
				object: item,
				filecategory: "adminincomedeclarations",
			});
			this.$store.dispatch("showAction", "showCreateEditAdminIncomeDeclarations");
		},
		deleteAdminIncomeDeclarations() {
			const self = this;
			let message = self.$t("global.delete_confirm_message_pre");
			if (self.selected_adminincomedeclarations.length <= 1) {
				message += self.$t("incomedeclarations.question_selected");
			} else {
				message += self.selected_adminincomedeclarations.length + self.$t("incomedeclarations.question_multiple_selected");
			}
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("global.delete_confirm_title"),
				message: message,
				okCb: () => {
					self.selected_adminincomedeclarations.forEach((element) => {
						self.$store.dispatch("deleteAdminIncomeDeclarations", element.id).then((res) => {
							self.$functions.actionOnSelection(res, self.selected_adminincomedeclarations);
						});
					});
				},
			});
		},
	},
	watch: {
		adminincomedeclarations_options: {
			handler(val) {
				this.loadAdminIncomeDeclarations();
			},
			deep: true,
		},
	},
};
</script>
